import { api } from "../api";
import { useCarica } from "../carica";

export function AvvisoDemo() {
  const stato = useCarica(() => api.leggi<{ demo?: boolean }>("/api/health"), []);
  if (!stato.dati?.demo) return null;
  return <aside className="avviso-demo" aria-label="Ambiente demo">
    <strong>Demo con dati fittizi.</strong> Le operazioni restano in questo ambiente.
  </aside>;
}
